import React from 'react';
import styles from './CodeSnippet.module.css';
import InlineChromiumBugfix from '../../../../components/InlineChromiumBugfix';
import {
  type CodeSnippetElement,
  type ComponentProps,
} from '../../../../types/aha-editor';

const CodeSnippet: React.FC<ComponentProps<CodeSnippetElement>> = ({
  attributes,
  children,
}) => (
  <span className={styles.codeSnippet} {...attributes}>
    <InlineChromiumBugfix />
    {children}
    <InlineChromiumBugfix />
  </span>
);
export default CodeSnippet;
